export default __webpack_public_path__ + "static/media/light_3_placeholder.e249c5d2.jpg";